import React from 'react';
import { StyledSlideout } from './Slideout.style';
import type { SlideoutProps } from '@makemydeal/dr-ui-bricks-types';

const Slideout: React.FC<SlideoutProps> = ({
    show,
    title,
    onClose,
    children,
    className = '',
    dataTestId = 'dr-slideout',
    backdropExcludeClasses,
    hideCloseIcon = false,
    panelSize = '648px',
    position = 'right'
}) => {
    return (
        <StyledSlideout
            show={show}
            title={title}
            onClose={onClose}
            dataTestId={dataTestId}
            backdropExcludeClasses={backdropExcludeClasses}
            hideCloseIcon={hideCloseIcon}
            panelSize={panelSize}
            position={position}
            className={className}
        >
            {children}
        </StyledSlideout>
    );
};

export default Slideout;
